import colors from "./colors";

const shadows = {
  10: "0px 1px 1px rgba(9, 30, 66, 0.25)",
  20: "0px 3px 5px rgba(9, 30, 66, 0.05)",
  30: "0px 8px 12px rgba(9, 30, 66, 0.03)",
  40: "0px 10px 18px rgba(9, 30, 66, 0.03)",
  50: "0px 18px 30px rgba(9, 30, 66, 0.03)",
  60: "0px 18px 30px rgba(9, 30, 67, 0.03)",
  outline: `0px 0px 3px 0px ${colors.brand[400]}`,
  dropdown: "0px 0px 1px rgba(9, 30, 67, 0.2), 0px 18px 28px rgba(9, 30, 67, 0.1)",
};

export default shadows;
